import { GCashButton } from '@src/components/Button';
import { useCallback } from 'react';

const LOGIN_PAGE_PATH = '/login.html';

export function UnauthorizedPage() {
  const handleRefresh = useCallback(() => {
    window.location.replace(LOGIN_PAGE_PATH);
  }, []);

  return (
    <main className="bg-color-bg relative flex h-dvh w-screen items-center justify-center overflow-hidden px-6 py-10">
      <div className="bg-blue-90/80 absolute -top-20 -left-16 size-56 rounded-full blur-3xl" />
      <div className="bg-blue-70/50 absolute -right-10 -bottom-20 size-64 rounded-full blur-3xl" />

      <section className="border-color-border-strong bg-color-bg-main shadow-depth-0 relative z-10 w-full max-w-md rounded-3xl border p-8">
        <img alt="GCash" className="h-9 w-auto" src="/gcash.svg" />

        <div className="mt-7 flex items-center gap-4">
          <div className="border-color-border-warning-weak bg-color-bg-warning-weaker flex size-16 items-center justify-center rounded-2xl border">
            <svg aria-hidden="true" fill="none" height="28" viewBox="0 0 24 24" width="28">
              <path
                d="M12 8.5V12.5M12 16.5H12.01M4.9 19H19.1C20.64 19 21.6 17.33 20.82 16L13.72 3.9C12.95 2.57 11.05 2.57 10.28 3.9L3.18 16C2.4 17.33 3.36 19 4.9 19Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
              />
            </svg>
          </div>
          <div>
            <p className="text-color-text-primary text-base font-bold tracking-[0.14em] uppercase">Unauthorized</p>
            <p className="text-color-text-stronger mt-1 text-sm font-semibold">Access restricted</p>
          </div>
        </div>

        <h1 className="text-color-text mt-7 text-2xl leading-tight font-extrabold">
          We could not verify your session.
        </h1>
        <p className="text-color-text-weak mt-3 text-base leading-7">
          Your session may have expired or this page requires a fresh login. Tap refresh to attempt to log in again.
        </p>

        <div className="mt-8 flex">
          <GCashButton className="h-12" onClick={handleRefresh}>
            Refresh
          </GCashButton>
        </div>
      </section>
    </main>
  );
}
